export class RelatedEntityData {
    contactId?: number;
    mappingId?: number;
    isAdd: boolean;
    relatedEntityTypeId: number;
    contactTypeId: number;
    legalEntity: string;
    isReadOnlyMode: boolean;
}